module.exports = __webpack_public_path__ + "img/55.7159a9b2.png";